import React, { useEffect, useState } from 'react';
import { Typography } from '@material-ui/core';
import { carbonRequest } from './api';
import { CarbonSelectInput } from './CarbonAdminPage';
import { reportingRevisionStatusLabel } from './workflow';

// Used by account-wide histories; an empty value means all reporting revisions.
export const ReportingRevisionFilter = ({ token, value, onChange, inventoryId = '', onInventoryChange }) => {
  const [inventories, setInventories] = useState([]);
  const [revisions, setRevisions] = useState([]);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    setInventories([]); setRevisions([]); setError('');
    if (token) carbonRequest(token, 'corporate-carbon/inventories').then(rows => { if (!Array.isArray(rows)) throw new Error('Invalid inventories'); if (active) setInventories(rows); }).catch(() => { if (active) setError('Reporting year filters are unavailable.'); });
    return () => { active = false; };
  }, [token]);
  useEffect(() => {
    let active = true;
    setRevisions([]);
    if (inventoryId) carbonRequest(token, `corporate-carbon/inventories/${inventoryId}/revisions`).then(rows => { if (!Array.isArray(rows)) throw new Error('Invalid revisions'); if (active) setRevisions(rows); }).catch(() => { if (active) setError('Reporting revision filters are unavailable.'); });
    return () => { active = false; };
  }, [token, inventoryId]);
  return <>
    <CarbonSelectInput label="Reporting year" name="filterInventory" choices={inventories} choiceText={row => String(row.reportingYear)} value={inventoryId} emptyText="All years" onChange={event => { onInventoryChange(event.target.value); }} />
    <CarbonSelectInput label="Reporting revision" name="filterRevision" choices={revisions} choiceText={reportingRevisionStatusLabel} value={value} emptyText="All revisions" onChange={event => onChange(event.target.value)} />
    {error && <Typography role="alert">{error}</Typography>}
  </>;
};
